import {AfterContentInit, ChangeDetectorRef, ContentChild, Directive, Injector, Input, OnDestroy} from "@angular/core";
import {TranslateService} from "@ngx-translate/core";
import {forkJoin, map} from "rxjs";
import {SelectOptionsComponent} from "../../../select/options/select-options.component";
import {AbstractColumnComponent} from "../../../grid/abstract-column.component";

@Directive()
export class AbstractSelectColumnComponent extends AbstractColumnComponent implements AfterContentInit, OnDestroy {
    @Input() readonly: boolean;

    @ContentChild(SelectOptionsComponent) selectOptionsComponent: SelectOptionsComponent;

    translateService: TranslateService;
    changeDetectorRef: ChangeDetectorRef;

    data: Array<any> = [];
    valueField: string;
    labelField: string;

    private destroyed: boolean;

    constructor(injector: Injector, valueField: string = "value", labelField: string = "label") {
        super(injector);
        this.translateService = injector.get(TranslateService, null);
        this.changeDetectorRef = injector.get(ChangeDetectorRef, null);
        this.valueField = valueField;
        this.labelField = labelField;
    }

    ngAfterContentInit(): void {
        if (this.selectOptionsComponent) {
            this.selectOptionsComponent.data$.subscribe(data => {
                if (!this.destroyed) {
                    this.data = data;
                    this.changeDetectorRef.detectChanges();
                }
            });
        }
    }

    ngOnDestroy(): void {
        this.destroyed = true;
    }

    buildData(options: { label: string, value?: any }[]): void {
        forkJoin(
            options.map(option =>
                this.translateService.get(option.label).pipe(
                    map(translation => ({
                        [this.labelField]: translation,
                        [this.valueField]: option.value === undefined ? translation : option.value
                    }))
                )
            )
        ).subscribe(results => this.data = results);
    }
}
